import cx from "classnames";
import dynamic from "next/dynamic";
import React from "react";

const HowItWorks = dynamic(() => import("../commons/how-it-works"), { ssr: true });

const InvoiceLinksHowItWorks = () => {
  return (
    <HowItWorks
      headerTextSeries={[
        ["How", "to", "collect", "payments"],
        ["with", "invoice", "links"],
      ]}
      steps={steps}
    />
  );
};

const steps = [
  {
    description: "Create an invoice with customer details & items purchased",
    image: "https://res.cloudinary.com/catlog/image/upload/v1671003112/front-pages/mockups/invoice-created-mobile.webp",
  },
  {
    description: "Share invoice with customers via Whatsapp or any other options",
    image:
      "https://res.cloudinary.com/catlog/image/upload/v1671003112/front-pages/mockups/seller-sends-invoice-link.webp",
  },
  {
    description: "Customers click on this link and pay with any option they like",
    image:
      "https://res.cloudinary.com/catlog/image/upload/v1671003112/front-pages/mockups/customer-paying-invoice.webp",
    mockupConf: {
      from: "-70%",
      to: "-35%",
    },
  },
  {
    description: "Their payments is confirmed instantly, and your customer get receipts",
    image:
      "https://res.cloudinary.com/catlog/image/upload/v1671003113/front-pages/mockups/invoice-payment-successful.webp",
    mockupConf: {
      from: "-70%",
      to: "-35%",
    },
  },
];

export default InvoiceLinksHowItWorks;
